import { User } from "./user.model";

export interface LeaveRequest {
  id: number;
  days: number;
  fromDate: Date;
  fromDateIsAm: boolean;
  toDate: Date;
  toDateIsAm: boolean;
  user: User;
  status: ApprovalType;
  type: string; // convert leavetypeid to string
  reason?: string;
  fileUrl?: string;
  createdAt: Date;
}

export interface LeaveRequestDTO {
  id: number;
  days: number;
  fromDate: Date;
  fromDateIsAm: boolean;
  toDate: Date;
  toDateIsAm: boolean;
  user: User;
  status: ApprovalType;
  type: string; // convert leavetypeid to string
  reason?: string;
  fileUrl?: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface CreateLeaveRequestArgs {
  days: number;
  leaveType: string;
  fromDate: Date;
  fromDateIsAm: boolean;
  toDate: Date;
  toDateIsAm: boolean;
  userId: number;
  reason?: string;
  fileUrl?: string;
}

export enum ApprovalType {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}

export const ApprovalTypeLabels: { [key in ApprovalType]: string } = {
  [ApprovalType.PENDING]: "Pending",
  [ApprovalType.APPROVED]: "Approved",
  [ApprovalType.REJECTED]: "Rejected",
};
